<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Together Again?</title>
<link href="9781488078415.css" rel="stylesheet" type="text/css"/>
<h2 class="h2">CONTENTS</h2>
<p class="toc"><a href="#/9781488078415_Chapter_1#ch1">Chapter 1</a></p>
<p class="toc"><span href="#/9781488078415_Chapter_2#ch2" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc"><span href="#/9781488078415_Chapter_3#ch3" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc"><span href="#/9781488078415_Chapter_4#ch4" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc"><span href="#/9781488078415_Chapter_5#ch5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc"><span href="#/9781488078415_Chapter_6#ch6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc"><span href="#/9781488078415_Chapter_7#ch7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc"><span href="#/9781488078415_Chapter_8#ch8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc"><span href="#/9781488078415_Chapter_9#ch9" title="Link target outside of Sample">Chapter 9</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781488078415_Contents.vue?4304362e